import { AdminCreateWorkspace } from "../create/AdminCreateWorkspace";

export default function ComposePage() {
  return <AdminCreateWorkspace />;
}
